import React from 'react';
import HeroBackgroundImage from './HeroBackgroundImage';
import HeroBottomMessage from './HeroBottomMessage';
import HeroContent from './HeroContent';
import HeroHeader from './HeroHeader';
import styles from './onboardingHero.module.css';
import { LANDPAGE_HERO, type OnboardingHeroCopy } from '../../landpage.constants';

interface OnboardingHeroSectionProps {
  copy?: OnboardingHeroCopy;
}

const OnboardingHeroSection: React.FC<OnboardingHeroSectionProps> = ({
  copy = LANDPAGE_HERO,
}) => {
  return (
    <section className={styles.heroSection}>
      <div className={styles.heroVisual}>
        <div className={styles.heroBackground}>
          <HeroBackgroundImage
            src={copy.backgroundImageSrc}
            alt={copy.backgroundImageAlt}
            objectPosition={copy.backgroundImagePosition}
            topCropPx={copy.backgroundImageTopCrop}
          />
        </div>
        <HeroHeader
          supportLabel={copy.supportButtonLabel}
          supportHref={copy.supportWhatsAppUrl}
        />
        <div className={styles.headerDivider} aria-hidden="true" />
        <HeroContent
          titleLineOne={copy.titleLineOne}
          titleLineTwo={copy.titleLineTwo}
        />
      </div>

      <HeroBottomMessage
        lineOne={copy.bottomMessageLineOne}
        lineTwo={copy.bottomMessageLineTwo}
      />
    </section>
  );
};

export default OnboardingHeroSection;
